/// <amd-module name="typeahead/core/logging/SelectionToSubmissionMetric" />

import {TypeaheadMetric} from "typeahead/core/logging/TypeaheadMetric";

export class SelectionToSubmissionMetric extends TypeaheadMetric {

    public latency: number;

    constructor(lob: string, elementId: string, suggestionSelectedTimestamp: number, submitClickedTimestamp: number,
                activeESSTests: string) {
        super(lob, elementId, "selectionToSubmission", activeESSTests);
        this.latency = submitClickedTimestamp - suggestionSelectedTimestamp;
    }
}
